import React from "react";

const VegetarianFriendly = ({ fill, light, size }) => {
  return (
    <svg
      width={size || "72"}
      height={size || "72"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      className="m-1"
    >
      <g id="vegetarian_1_">
        <path
          id="circle_1_"
          d="M25,50C11.2,50,0,38.8,0,25C0,11.2,11.2,0,25,0s25,11.2,25,25C50,38.8,38.8,50,25,50z M25,1.1
		C11.8,1.1,1.1,11.8,1.1,25c0,13.2,10.7,23.9,23.9,23.9S48.9,38.2,48.9,25C48.9,11.8,38.2,1.1,25,1.1z"
          fill={fill}
        />
        <path
          id="text_1_"
          d="M13.2,20.7L13,21.4l-7.7-0.8l0.3-0.8l5.6,0.7c0.2,0,0.7,0.1,1,0.2l0,0c-0.3-0.1-0.8-0.3-0.9-0.4
		l-4.8-2.8l0.3-0.8L13.2,20.7z M9.9,12.7l-1.1,1.5l2.2,1.5l1-1.5l0.5,0.4l-1,1.5l2.4,1.7l1.1-1.5l0.5,0.4L14,18.9l-6.2-4.3l1.5-2.2
		L9.9,12.7z M14.8,12l1.5-1.2l0.9,1.1c0.7,0.9,1.6,2.2,0.2,3.2c-1.4,1.1-2.6-0.1-4-2c-1.1-1.4-2.1-3-0.7-4.2c0.8-0.6,1.6-0.5,2.2,0
		l-0.4,0.7c-0.3-0.3-0.9-0.6-1.3-0.2c-0.9,0.7,0,2,0.8,3.1c1.7,2.2,2.4,2.5,3.1,1.9c0.7-0.5,0.4-1.1-0.6-2.3l-0.4-0.4l-0.9,0.7
		L14.8,12z M19.3,6.4L17.6,7l1,2.5l1.7-0.7l0.2,0.6l-1.7,0.7l1.1,2.8l1.8-0.7l0.2,0.6l-2.5,1l-2.7-7l2.5-1L19.3,6.4z M24.5,5.5
		l-1.3,0.1l0.8,6.9l-0.8,0.1l-0.8-6.9l-1.3,0.1l-0.1-0.6l3.3-0.4L24.5,5.5z M28.6,12.8l-0.8-0.1l-0.1-1.6l-1.8-0.2l-0.5,1.5
		l-0.8-0.1L27.1,5l0.7,0.1L28.6,12.8z M27.6,10.5l-0.2-2.9c0-0.5,0-1,0-1.6l0,0c-0.1,0.5-0.3,1-0.4,1.5l-0.8,2.8L27.6,10.5z
		 M28.8,12.9l3.1-6.9l0.8,0.3c1.1,0.5,2.1,1,1.3,2.7c-0.4,0.9-1,1.6-2.2,1.1l0.2,4.1L31.2,14L31,9.9l0,0l-1.5,3.4L28.8,12.9z
		 M31.2,9.4l0.3,0.1c1,0.5,1.3,0.2,1.7-0.7c0.5-1.1,0.2-1.4-0.7-1.8L32.3,7L31.2,9.4z M32.9,15.2l-0.6-0.5l4.5-6l0.6,0.5L32.9,15.2z
		 M35.9,18.4l-0.5-0.6l1-1.2l-1.2-1.4l-1.4,0.8l-0.5-0.6l6.8-3.6l0.5,0.6L35.9,18.4z M36.7,16l1.8-2.3c0.3-0.4,0.7-0.8,1-1.2l0,0
		c-0.4,0.3-0.9,0.6-1.3,0.8l-2.5,1.5L36.7,16z M37.4,21.8l-0.3-0.6l3.9-3.7c0.2-0.2,0.5-0.4,0.8-0.6l0,0c-0.4,0.2-0.9,0.5-1.3,0.6
		l-4.2,1.8L36,18.6l7-2.9l0.3,0.6l-4.1,3.8c-0.2,0.2-0.4,0.4-0.6,0.5l0,0c0.3-0.1,0.6-0.3,0.9-0.5l4.6-1.9l0.3,0.6L37.4,21.8z
		 M15.8,34.2l-1.2-1.5l-2.1,1.6l1.1,1.4l-0.5,0.4L12,34.7l-2.8,2.2l-0.5-0.6l5.9-4.7l1.7,2.1L15.8,34.2z M12.4,40.3l4.4-6.2l0.7,0.5
		c1,0.7,1.8,1.4,0.8,2.9c-0.6,0.8-1.3,1.4-2.4,0.7l-0.6,4.1l-0.7-0.5l0.7-4.1l0,0l-2.1,3L12.4,40.3z M15.5,37.3l0.2,0.2
		c0.9,0.6,1.2,0.5,1.8-0.3c0.7-1,0.4-1.3-0.4-1.9L17,35.2L15.5,37.3z M17.7,43.4L17,43.1l2.9-6.9l0.7,0.3L17.7,43.4z M24,38
		l-1.8-0.4l-0.5,2.6l1.8,0.4l-0.1,0.6l-1.8-0.4l-0.6,2.9l1.8,0.4l-0.1,0.6L20,44.2l1.4-7.4l2.6,0.5L24,38z M28.7,44.6L28,44.6
		l-2.4-4.9c-0.2-0.3-0.3-0.6-0.4-0.9l0,0c0.1,0.5,0.2,1,0.2,1.4l0.4,4.6l-0.7,0.1l-0.7-7.5l0.7-0.1l2.4,5c0.1,0.2,0.2,0.5,0.3,0.8
		l0,0c-0.1-0.3-0.1-0.7-0.2-1l-0.5-5l0.7-0.1L28.7,44.6z M28.5,36.9l0.8-0.3c1.5-0.7,2.5-0.9,4,2.4c1.2,2.7,1,3.7-0.9,4.5l-0.8,0.4
		L28.5,36.9z M32,42.9l0.2-0.1c1.4-0.6,1.2-1.6,0.3-3.6c-1-2.4-1.5-2.7-2.9-2.1l-0.1,0.1L32,42.9z M36.7,40.2l1.5-1.1l0.4,0.5
		l-2.1,1.6l-4.7-5.9l0.6-0.5L36.7,40.2z M38,35.2l2.5,2.1L40,38l-2.5-2.1l-4.3-1.4l0.5-0.6l2.5,1c0.3,0.1,0.6,0.3,1,0.4l0,0
		c-0.2-0.3-0.5-0.6-0.7-0.9L35.2,32l0.5-0.6L38,35.2z"
          fill={light ? "#595A5A" : "#fff"}
        />
        <path
          id="leaf_1_"
          d="M7.5,28.1c9.4-7.3,15.5-1.1,26-2c-6.2,0.4-12.8-3.7-19.1-2.5c1.6-7.1,9.9-3.5,15.1-0.7
		c2.4,1.3,6.7,1.9,9.7,0.7C36,31.9,23,38.5,14.5,26C12.9,25.8,10.2,26.5,7.5,28.1z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default VegetarianFriendly;
